import { db } from './database';

export async function getUser(authUserId) {
    const user = await db.doc(`users/${authUserId}`).get();
    return user.data();
}
